export default __webpack_public_path__ + "static/media/Fig4.3f9ede29.jpg";